import React, { useMemo } from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { BooleanInput, useLocaleState, useTranslate } from 'react-admin'
import { PermissionTableProps } from './type'
import { ROLES_FIELDS } from '../../../providers/localization/constant'
import isEmpty from 'lodash/isEmpty'

const PERMISSIONS_HEADER = ['create', 'read', 'update', 'delete' /* , 'export' , 'approve' */]

const TableHeader: React.FC = () => {
  const translate = useTranslate()
  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ backgroundColor: '#F1F1F1' }} key={'feature_header'}>
          {translate(`${ROLES_FIELDS}.feature`)}
        </TableCell>
        {PERMISSIONS_HEADER.map((action) => (
          <TableCell sx={{ backgroundColor: '#F1F1F1' }} key={`${action}_header`}>
            {translate(`${ROLES_FIELDS}.action.${action}`)}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const PermissionTable: React.FC<PermissionTableProps> = ({
  rolePermissionList = [],
  permissionKeys = [],
  disabled = false,
}) => {
  const [activeLocale] = useLocaleState()
  const permissionRow = useMemo(() => {
    if (isEmpty(rolePermissionList) || isEmpty(permissionKeys)) return []

    return rolePermissionList
      .map((permisison) => {
        const matchPermission = permissionKeys.find((el) => el.key === permisison.key)
        matchPermission.is_active = permisison.is_active
        return matchPermission
      })
      .filter((el) => {
        return !(
          !el.read_check &&
          !el.create_check &&
          !el.update_check &&
          !el.delete_check &&
          !el.export_check &&
          !el.approve_check &&
          !el.is_active
        )
      })
  }, [permissionKeys, rolePermissionList])

  if (isEmpty(permissionRow)) return null

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHeader />
        <TableBody>
          {permissionRow.map((item, idx) => (
            <TableRow key={item.key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell>{item[`name_${activeLocale}`]}</TableCell>

              <TableCell>
                {item['create_check'] && (
                  <BooleanInput
                    source={`permissions[${idx}].creatable`}
                    label=''
                    disabled={disabled}
                  />
                )}
              </TableCell>
              <TableCell>
                {item['read_check'] && (
                  <BooleanInput
                    source={`permissions[${idx}].readable`}
                    label=''
                    disabled={disabled}
                  />
                )}
              </TableCell>
              <TableCell>
                {item['update_check'] && (
                  <BooleanInput
                    source={`permissions[${idx}].updatable`}
                    label=''
                    disabled={disabled}
                  />
                )}
              </TableCell>
              <TableCell>
                {item['delete_check'] && (
                  <BooleanInput
                    source={`permissions[${idx}].deletable`}
                    label=''
                    disabled={disabled}
                  />
                )}
              </TableCell>
              {/* <TableCell>
                {item['export_check'] && (
                  <BooleanInput
                    source={`permissions[${idx}].exportable`}
                    label=''
                    disabled={disabled}
                  />
                )}
              </TableCell> */}
              {/* <TableCell >
                {item['approve_check'] && (
                  <BooleanInput source={`permissions[${idx}].approvable`} label='' />
                )}
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default PermissionTable
